const heroBanner = document.querySelector('.js-hero-banner');


const height = window.innerHeight * 0.5;

function setOpacity() {
    const opacity = ((height - window.pageYOffset) / height);
    heroBanner.style.opacity = Math.min(1, Math.max(0, opacity));
    window.requestAnimationFrame(setOpacity);
}

if (heroBanner) {
    setOpacity();
}



// WEBPACK FOOTER //
// ./src/js/features/heroBanner.js